import { types } from "../types/types";
import { resolveCompanyLogoUrl } from '../helpers/company-helper';

export const companyReducer = ( state = {}, action ) => {
    switch ( action.type ) {
        case types.setCompany:
            return {
                id: action.payload.id,
                name: action.payload.name,
                subscription: action.payload.subscription,
                storage: action.payload.storage,
                adminEmailVerified: action.payload.adminEmailVerified,
                settings: action.payload.settings,
                logoUrl: resolveCompanyLogoUrl(action.payload.settings),
            }
        case types.updateEmailVerified:
            return {
                ...state,
                adminEmailVerified: action.payload.adminEmailVerified
            }
        case types.updateCompanyName:
            return {
                ...state,
                name: action.payload.name,
            }
        case types.updateCompanyLogo:
            return {
                ...state,
                logoUrl: String(action.payload.logoUrl || '').trim(),
            }
        case types.updateCompanySettings:
            return {
                ...state,
                settings: action.payload.settings,
                logoUrl: resolveCompanyLogoUrl(action.payload.settings),
            }
        case types.unsetCompany:
            return {}
        default:
            return state;
    }
}